
require(["pwa/pages/CommunityDetail/show"]);
